<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Loading Types</li>
            </ol>
            <h4 class="main-title mb-2">Loading Types</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'loading_types.create'">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Loading Type</h6>
                            <h6 class="card-title" v-else>Update Loading Type</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Loading Type Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Loading Type Code" class="form-control" :class="{ 'is-invalid': errors.loading_type_code }" v-model="loading_type.loading_type_code" ref="loading_type_code" />
                                    <span v-if="errors.loading_type_code"><small class="text-danger">{{ errors.loading_type_code[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Loading Type Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Loading Type Name" class="form-control" :class="{ 'is-invalid': errors.loading_type_name }" v-model="loading_type.loading_type_name" />
                                    <span v-if="errors.loading_type_name"><small class="text-danger">{{ errors.loading_type_name[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Loading Types</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('loading_type_code')">Loading Type Code
                                            <span>
                                                <i v-if="meta.keyword=='loading_type_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='loading_type_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                        <th @click="sort('loading_type_name')">Loading Type Name
                                        
                                            <span>
                                                <i v-if="meta.keyword=='loading_type_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='loading_type_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                       
                                        <th class="text-center" v-can="'loading_types.delete'">Status</th>
                                        <th class="text-center" v-can="'loading_types.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loading_types.length==0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="loading_type, key in loading_types" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{loading_type.loading_type_code}}</td>
                                        <td>{{ loading_type.loading_type_name }}</td>
                                        <td class="text-center" v-can="'loading_types.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'loading_type' + loading_type.loading_type_id" :checked="loading_type.status" :value="loading_type.status" @change="deleteLoadingType(loading_type)" />
                                                <label class="custom-control-label" :for="'loading_type' + loading_type.loading_type_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'loading_types.update'">
                                            <a href="javascript:void(0)" v-if="loading_type.status" class="text-success me-2" @click="editLoadingType(loading_type)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column:'',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "loading_type_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                loading_type: {
                    loading_type_id: "",
                    loading_type_code: "",
                    loading_type_name: "",
                },
                status: true,
                loading_types: [],
                errors: [],
            };
        },
        mounted() {
            this.create_loadingtype = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('loading_types.create')
            })
            if(this.create_loadingtype.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addLoadingType();
                } else {
                    vm.updateLoadingType();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateLoadingTypes", data: vm.meta })
                    .then((response) => {
                        vm.loading_types = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addLoadingType() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addLoadingType", data: vm.loading_type })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Loading Type Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateLoadingType() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateLoadingType", data: vm.loading_type })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Loading Type is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editLoadingType(loading_type) {
                let vm = this;
                vm.$refs.loading_type_code.focus();
                vm.errors = [];
                vm.status = false;
                vm.loading_type = loading_type;
            },

            deleteLoadingType(loading_type) {
                let vm = this;
                let loader = vm.$loading.show();
                loading_type.status = loading_type.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deleteLoadingType", data: loading_type })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
                let vm = this;
                vm.loading_type.loading_type_code = "";
                vm.loading_type.loading_type_name = "";
                vm.$refs.loading_type_code.focus();
                vm.errors = [];
                vm.status = true;
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            
        },
    };
</script>
